import { withStyles, createStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

export const TableHeaderCell = withStyles((theme: any) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary[500],
      fontWeight: 'bold',
      color: theme.palette.common.white,
    },
  }),
)(TableCell);

export const HighlightedTableCell = withStyles(() =>
  createStyles({
    root: {
      backgroundColor: '#e6e6e6',
      fontWeight: 'bold',
    },
  }),
)(TableCell);
